// extracted by css-extract-rspack-plugin
export default {"cls1":"RelatedPapers-cls1_RWb","cls2":"RelatedPapers-cls2_VLe RelatedPapers-cls1_RWb"};